import { toast } from 'react-toastify';

export const showToast = (message, type = 'info') => {
  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    case 'warning':
      toast.warning(message);
      break;
    case 'info':
    default:
      toast.info(message);
      break;
  }
};

export const showFileUploadFailureToast = (invalidFiles) => {
  toast.error(
    <div>
      <div>
        <strong>{invalidFiles.length}</strong> file
        {invalidFiles.length === 1 ? '' : 's'} could not be uploaded:
      </div>
      <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
        {invalidFiles
          .filter((file) => file.fileName)
          .map((file, index) => (
            <li key={index} style={{ fontSize: '12px', margin: '2px 0' }}>
              <strong>{file.fileName}:</strong>{' '}
              {file.error || 'An unexpected error occurred'}
            </li>
          ))}
      </ul>
    </div>
  );
};
